import {admin, Employee, ServiceRep} from './admin';
import {adminagent, otheruser } from './agent';
import { profile } from './profile';

const menuItems: any = {
    admin: [admin],
    employee: [Employee],
    ServiceRep: [ServiceRep],
    driver: [adminagent],
    profile: [profile],
    otheruser: [otheruser]

};

export default menuItems;
